import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './components/Sidebar/Sidebar';
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import { useTheme } from './hooks/useTheme';
import './App.css';

export function AppLayout() {
  const { theme, toggle: toggleTheme } = useTheme();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Desktop: hamburger collapses to an icon rail. Mobile: it opens the off-canvas drawer.
  const toggleSidebar = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      setMobileOpen((o) => !o);
    } else {
      setCollapsed((c) => !c);
    }
  };

  return (
    <div className="layout">
      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <div className="layout__main">
        <Header theme={theme} onToggleSidebar={toggleSidebar} onToggleTheme={toggleTheme} />
        <main className="layout__content">
          <Outlet />
        </main>
        <Footer />
      </div>

      {mobileOpen && <div className="layout__backdrop" onClick={() => setMobileOpen(false)} />}
    </div>
  );
}
